<template>
  <div id="exports_section" class="flex flex-col gap-6">
    <h1 class="text-xl font-semibold text_color">Exports</h1>
    <div
      v-if="loading"
      class="flex flex-col items-center justify-center gap-2 mt-20"
    >
      <CustomLoader :size="28" />
    </div>

    <CustomTable
      v-else-if="exports?.length > 0"
      source="export"
      :headers="headers"
      :data="exports"
      :pagination="pagination"
      height="calc(100vh - (280px + var(--banner-height)))"
      :custom-column-render="customColumnRender"
      @refresh="fetchExports"
      @update:pagination="handlePageChange"
    />

    <EmptyScreen source="block_list" text="No Exports Found!" v-else />
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import CustomTable from "@/src/components/custom_table_components/CustomTable.vue";
import EmptyScreen from "@/src/components/EmptyScreen.vue";
import CustomLoader from "@/src/components/CustomLoader.vue";

import ExportListActions from "@/src/views/exports/ExportListActions.vue";
import DashboardService from "@/src/api/DashboardService.js";

const loading = ref(false);
const headers = [
  { label: "Name", key: "name", width: 3 },
  { label: "Type", key: "export_type", width: 2 },
  { label: "Export Size", key: "size", width: 2 },
  { label: "Exported By", key: "exported_by", width: 2, view: true },
  { label: "Date", key: "exported_at", width: 2 },
  { label: "", key: "actions", width: 1 },
];
const exports = ref([]);
const pagination = ref({ current: 1, pageSize: 20, total: 0 });
const customColumnRender = {
  actions: ExportListActions,
};

const handlePageChange = (newPagination) => {
  pagination.value = newPagination;
  if (newPagination.selection) {
    pagination.value.current = 1;
  }
  fetchExports();
};

const fetchExports = async () => {
  loading.value = true;
  try {
    const params = {
      page: pagination.value.current - 1,
      page_size: pagination.value.pageSize,
    };
    const response = await DashboardService.fetchExports(params);
    if (response.success) {
      exports.value = response.exports;
      pagination.value.total = response?.total_count || exports.value.length;
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchExports();
});
</script>
